export const REGEXP_VALID_EMAIL = /^[^\s@]+@[^\s@]+$/
